import { Link, usePush } from '@dreryk/react-components';

import { medicalDocumentationCreateTranslationKeys } from '../../../translations';

// TODO: DREGAB-4137 Replace with on strong typed paths from common module
const MY_ACCOUNT_PATH = '/moje-konto/dane-osobowe';

export const MyAccountLink = (): JSX.Element => {
   const push = usePush();

   const handleClick = (): void => {
      push(MY_ACCOUNT_PATH);
   };

   return (
      <Link
         testId={'myAccount'}
         label={medicalDocumentationCreateTranslationKeys.myAccount}
         block={false}
         onClick={handleClick}
      />
   );
};
